import React, { FC } from 'react';
import { ToggleSwitchProps } from './toggleSwitch.types';
import { StyledToggleSwitch } from './toggleSwitch.styles';

const ToggleSwitch: FC<ToggleSwitchProps> = ({ className, clickHandler, tab1Label, tab2Label, activeTab }) => {
  const clickTrackingLoc = 'Search Form';

  return (
    <StyledToggleSwitch data-component-name="a-shop-ToggleSwitch" data-testid="shop-ToggleSwitch" className={className}>
      <span>
        <button
          type="button"
          className={` custom_click_track 
          m-button-s ${activeTab === tab1Label ? 'm-button-primary active-btn' : 'm-button-secondary'} first-btn `}
          {...{
            custom_click_track_value: `${clickTrackingLoc}| Flexible Date Picker Toggle ${tab1Label} button |internal`,
          }}
          onClick={(): void => clickHandler(tab1Label)}
          aria-disabled={activeTab === tab2Label}
        >
          {tab1Label}
        </button>
      </span>
      <span>
        <button
          type="button"
          className={`custom_click_track m-button-s ${
            activeTab === tab2Label ? 'm-button-primary active-btn' : 'm-button-secondary'
          } second-btn `}
          {...{
            custom_click_track_value: `${clickTrackingLoc}| Flexible Date Picker Toggle ${tab2Label} button |internal`,
          }}
          onClick={(): void => clickHandler(tab2Label)}
          aria-disabled={activeTab === tab1Label}
        >
          {tab2Label}
        </button>
      </span>
    </StyledToggleSwitch>
  );
};

export default ToggleSwitch;
